export const user = {
    state: {
        manageUserModal: {
            show: false
        },
    },
    mutations: {
        setManageUserModalShow(state, show) {
            state.manageUserModal.show = show;
        },
    },
    getters: {
        getManageUserModalShow(state) {
            return state.manageUserModal.show;
        },
    },
    actions: {
        showManageUserModal({ commit }) {
            commit('setManageUserModalShow', true);
        },
        hideManageUserModal({ commit }) {
            commit('setManageUserModalShow', false);
        },
    },
};
